import type { ReactNode } from 'react'

import { cn } from '@/utils'
import { LoadingStatementBar } from './LoadingStatementBar'
import { LOADING_FILES, PENDING_DIM } from './PendingNote'
import { PANEL_SECTION } from './panelLayout'
import { StatementStepper } from './StatementStepper'

interface OpenStatementProps {
  position: number
  total: number
  filesArriving: boolean
  stripMoving: boolean
  onPrevious: (() => void) | null
  onNext: (() => void) | null
  // The statement bar, shown once the files are in.
  children: ReactNode
}

// The stepper is always there, so it never shifts the column: where you are in the file at rest,
// what is being waited for while the strip moves.
export const OpenStatement = ({
  position,
  total,
  filesArriving,
  stripMoving,
  onPrevious,
  onNext,
  children,
}: OpenStatementProps) => (
  <div className={cn(PANEL_SECTION, 'border-b')}>
    <StatementStepper
      position={position}
      total={total}
      waiting={filesArriving || stripMoving}
      waitingText={filesArriving ? LOADING_FILES : undefined}
      onPrevious={onPrevious}
      onNext={onNext}
    />
    {filesArriving ? (
      <LoadingStatementBar />
    ) : (
      <div className={cn(stripMoving && PENDING_DIM)}>{children}</div>
    )}
  </div>
)
